<template>
  <div class="container">
    <!-- Modal -->
    <div :class="[(this.$store.state.permissaoNegada.permissaoNegada.show === true) ? 'in show' : '', 'modal fade permissaoNegada']" id="permissaoNegada" role="dialog">
      <div class="modal-dialog">

        <!-- Modal content-->
        <div class="modal-content">
          <div :class="[(this.$store.state.permissaoNegada.permissaoNegada.status) ? 'sucesso' : 'falhou', 'modal-header']">

            <button type="button" class="close" data-dismiss="modal" v-on:click="fecharModal()">&times;</button>

            <h4 class="modal-title alert-title" v-if="this.$store.state.permissaoNegada.permissaoNegada.status"> Sucesso! <span> <b-icon-unlock-fill></b-icon-unlock-fill> </span> </h4>

            <h4 class="modal-title alert-title" v-else> Acesso negado! <span> <b-icon-lock-fill></b-icon-lock-fill> </span></h4>

          </div>
            <div class="modal-body alert-body" v-html="this.$store.state.permissaoNegada.permissaoNegada.msg"></div>
          <div class="modal-footer">
            <button type="button" class="btn btn-default" data-dismiss="modal" v-on:click="fecharModal()">Fechar</button>
          </div>
        </div>

      </div>
    </div>
  </div>

</template>
<script>
export default {
  methods: {
    fecharModal: function () {
      this.$store.commit('setPermissaoNegada', {msg: '', status: true, show: false})
      this.$router.push('/')
    }
  }
}
</script>
<style scoped>
  .permissaoNegada {
    transition: 1s;
  }
  .alert-title {
    text-align: center;
    font-size: 1.7em;
  }
  .alert-body {
    font-size: 1.2em;
    padding: 2em;
    text-align: center;
  }
  .sucesso {
    color: #155724;
    background-color: #d4edda;
    border-color: #c3e6cb;
  }
  .falhou {
    color: #FFF;
    background-color: #2196F3;
  }
  .alert-title span {
    /* transform: rotate(90deg); */
    display: inline-block;
    font-size: 1.1em;
    margin-left: .5em;
    font-weight: 600;
  }
  .modal {
    z-index: 900000;
  }
</style>



// WEBPACK FOOTER //
// PermissaoNegada.vue?8c33e1fa